import React, { useState } from 'react';
import withLoading from './hocs/LoadingHOC';
import Home from '../../assets/customization/Home';
import InfoWarningIcon from '../../assets/InfoWarningIcon';

interface WelcomePageProps {
  loading: boolean;
  onTabChange: (tab: string) => void;
}

interface Option {
  number: number;
  description: string;
  link: string;
  hasRibbon: boolean;
  tooltip: string;
}

const WelcomePage: React.FC<WelcomePageProps> = ({ loading, onTabChange }) => {
  const Loading = withLoading("div");

  const options: Option[] = [
    { number: 1, description: "Tagline", link: `tagline`, hasRibbon: false, tooltip: "" },
    { number: 2, description: "Carousel", link: `carousel`, hasRibbon: false, tooltip: "" },
    { number: 3, description: "Featured Categories", link: `categories`, hasRibbon: false, tooltip: "Customization available in RetailSystem content page" },
    { number: 4, description: "Landscape Banner", link: `banner-landscape`, hasRibbon: false, tooltip: "" },
    { number: 5, description: "Side By Side", link: `side-by-side`, hasRibbon: false, tooltip: "" },
    { number: 6, description: "Values - Why Choose Us", link: `values`, hasRibbon: false, tooltip: "" },
    { number: 7, description: "Split Banner", link: `banner-split`, hasRibbon: false, tooltip: "" },
  ];

  return (
    <Loading isFetching={loading}>
      <div className="container welcome">
        <div className="topBar"></div>
        <div className="wrapperContent">
          <div className="row welcome-content">
            <div className="col-sm col-left welcome-text">
              <h1>Admin Edit</h1>
              <h2>Configurable sections of the Homepage</h2>
              <p className="description">
                Welcome, these are the sections you can edit and customize on your Homepage.<br />
                Please click on the area you want to edit or access them from the color menu.
              </p>
              <div className="sectionsMenu">
                {options.map((option, index) => (
                  <OptionButton
                    key={index}
                    number={option.number}
                    description={option.description}
                    hasRibbon={option.hasRibbon}
                    onClick={() => onTabChange(option.link)}
                    tooltip={option.tooltip}
                  />
                ))}
              </div>
            </div>
            <div className="col-sm col-right text-right welcome-image">
              <Home onTabChange={onTabChange} />
            </div>
          </div>
        </div>
      </div>
    </Loading>
  );
}

const getNumberWord = (num: number): string => {
  const words = ['one', 'two', 'three', 'four', 'five', 'six', 'seven'];
  return words[num - 1];
};

interface OptionButtonProps {
  number: number;
  description: string;
  hasRibbon: boolean;
  onClick: () => void;
  tooltip: string;
}

const OptionButton: React.FC<OptionButtonProps> = ({ number, description, hasRibbon, onClick, tooltip }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <a onClick={onClick}>
      <div className={`numberOption__wrapper ${getNumberWord(number)} ${!hasRibbon ? "active" : ""}`}>
        <div className={`numberOption__number ${!hasRibbon ? "active" : ""}`}>
          {number}
        </div>
        <div className={`numberOption__description ${!hasRibbon ? "active" : ""}`}>
          <p>{description}</p>
        </div>
        {hasRibbon && (
          <div className="ribbon-customization">
            <span>soon</span>
          </div>
        )}
        {tooltip && (
          <div className="tooltip-container">
            <div className='tooltip-icons' onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
              <InfoWarningIcon />
            </div>
          </div>
        )}
      </div>
      {showTooltip && tooltip != "" && (
        <div className="tooltip-box">
          <p>{tooltip}</p>
        </div>
      )}

    </a>
  );
}

export default WelcomePage;